import './content-slider.scss';
import { Slider } from '../slider/slider';

// module adaption in progress
class ContentSlider {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-content-slider',
            offset: 10,
            resizeTimeout: 50,
            navListClass: 'content-slider__nav-items'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$contentSlider = element;

        this.$$slides = this.$contentSlider.querySelectorAll('[' + this.settings.initAttr + '="slide"');
        this.currentIndex = 0;
        this.navItems = [];
        this.resizeTimer = null;

        // Create navigation elements
        this.$nav = document.createElement('nav');
        this.$nav.classList.add('content-slider__nav');
        this.$navList = document.createElement('ul');
        this.$navList.classList.add(this.settings.navListClass);
        this.$navIndicator = document.createElement('li');
        this.$navIndicator.classList.add('content-slider__nav-item', 'content-slider__nav-item--indicator');
        this.$navCounter = document.createElement('span');
        this.$navCounter.classList.add('content-slider__nav-counter');
        this.$navCounter.innerHTML = '<span data-contentslider-current></span> / <span data-contentslider-length></span>';
    }

    initialize () {
        this.initSlider(this.$contentSlider);
    }

    setIndicator (i) {
        const currentItem = this.navItems[i];
        const currentItemLeft = currentItem.offsetLeft - this.settings.offset;
        const currentItemWidth = currentItem.offsetWidth + 2 * this.settings.offset;

        this.$navIndicator.style.left = currentItemLeft + 'px';
        this.$navIndicator.style.width = currentItemWidth + 'px';

        this.$navCounter.querySelector('[data-contentslider-current]').textContent = i + 1;
    }

    initIndicators (slider) {
        const $$listItems = this.$navList.querySelectorAll('[data-contentslider-navitem]');

        $$listItems.forEach(item => {
            item.addEventListener('click', function () {
                const targetIndex = item.getAttribute('data-contentslider-navitem');
                slider.sliderSlideTo(targetIndex);
            });
        });

        this.$navCounter.querySelector('[data-contentslider-length]').textContent = this.navItems.length;
    }

    checkIndicatorWidth (items) {
        if (items.offsetWidth > this.$nav.offsetWidth) {
            this.$nav.classList.add('content-slider__nav--counter');
        } else {
            this.$nav.classList.remove('content-slider__nav--counter');
        }
    }

    initMoreButtons (slides) {
        slides.forEach(slide => {
            const $item = slide.querySelector('.content-slider__content');
            let $clonedItem;
            let itemBounds;
            let opened = false;

            slide.querySelector('[' + this.settings.initAttr + '="more"]').addEventListener('click', function () {
                if (!opened) {
                    opened = true;

                    $clonedItem = $item.cloneNode(true);
                    itemBounds = $item.getBoundingClientRect();

                    $clonedItem.classList.add('content-slider__content--overlay');
                    $clonedItem.style.top = itemBounds.top + 'px';
                    $clonedItem.style.left = itemBounds.left + 'px';
                    $clonedItem.style.width = itemBounds.width + 'px';
                    $clonedItem.style.height = itemBounds.height + 'px';

                    slide.closest('.content-slider').appendChild($clonedItem);
                    document.body.classList.add('no-scroll');

                    setTimeout(() => {
                        $clonedItem.classList.add('content-slider__content--overlay-active');
                        const $closeButton = $clonedItem.querySelector('.content-slider__content-more');
                        $closeButton.addEventListener('click', function () {
                            document.body.classList.remove('no-scroll');
                            $clonedItem.classList.remove('content-slider__content--overlay-active');
                            setTimeout(() => {
                                slide.closest('.content-slider').removeChild($clonedItem);
                                opened = false;
                            }, 500);
                        });
                    }, 100);
                }
            });
        });
    }

    initSlider (module) {
        this.$$slides.forEach((item, index) => {
            const itemText = item.querySelector('.content-slider__content-headline').textContent;
            const $navItem = document.createElement('li');
            $navItem.classList.add('content-slider__nav-item');
            $navItem.textContent = itemText;
            $navItem.setAttribute('data-contentslider-navitem', index);
            this.$navList.appendChild($navItem);
            this.navItems.push($navItem);
        });

        this.$navList.appendChild(this.$navIndicator);
        // this.$nav.appendChild(this.$navList);
        this.$nav.appendChild(this.$navCounter);
        this.$contentSlider.appendChild(this.$nav);

        this.slider = new Slider(module, {
            initAttr: this.settings.initAttr,
            speed: 750,
            simulateTouch: false,
            onInit: ($slider, $current, initialSlide) => {
                setTimeout(() => {
                    this.setIndicator(initialSlide);
                    this.initIndicators($slider);
                    this.checkIndicatorWidth(this.$navList);
                    this.initMoreButtons(this.$$slides);
                }, 10);
            },
            onSlideStart: () => {
                this.currentIndex = this.slider.slider.activeIndex;
                this.setIndicator(this.currentIndex);
            },
            onResize: () => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {
                    this.checkIndicatorWidth(this.$navList);
                    this.setIndicator(this.currentIndex);
                }, 50);
            }
        });
    }
}

export { ContentSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ContentSlider = $context.querySelectorAll('[data-content-slider="root"]');
        for (let i = 0; i < $$ContentSlider.length; i++) {
            const $ContentSlider = new ContentSlider($$ContentSlider[i]);
            $ContentSlider.initialize();
        }
    }
});
